import axios from "axios";
import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export default API;

// Resolve stored image paths (/api/files/...) to absolute URLs
export const resolveImg = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  return src;
};

export function useContent(collection) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get(`/content/${collection}`).then((r) => { if (alive) { setData(r.data); setLoading(false); } })
      .catch(() => { if (alive) { setData([]); setLoading(false); } });
    return () => { alive = false; };
  }, [collection]);
  return { data, loading };
}
